/* eslint-disable-next-line no-restricted-imports */
import type { UnionTypeFromArray } from '../models/unionTypeFromArray';

export const storageKeys = ['authentication', 'userPreferences'] as const;

export type StorageKeys = UnionTypeFromArray<typeof storageKeys>;
